import { Pagination } from "@mui/material";
import {
  ArchiveIcon,
  AvatarIcon,
  HomeIcon,
  PersonIcon,
  SewingPinFilledIcon,
} from "@radix-ui/react-icons";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { checkTagValidity, getStepsPosition } from "../../Utils/Utils";
import { LISTE_ABONNEMENT_VALIDATION_SP } from "../../Utils/constant";
import { IntentionDetailsModal } from "../../components/Intention/IntentionDetailsModal";
import { ContentLoading } from "../../components/Widget/ContentLoading";
import { Pbo } from "../../components/Widget/Pbo";
import { Periode } from "../../components/Widget/Periode";
import { useCommentaireStore } from "../../store/CommentaireStore";
import { useConfigStore } from "../../store/ConfigStore";
import { useStoreLivraison } from "../../store/livraisonStore";

const ValidationVente = () => {
  const store = useStoreLivraison();
  const commentaire = useCommentaireStore();
  const [selectedIntention, setSelectedIntention] = useState(null);
  const param = useConfigStore();
  const [statut, setStatut] = useState("EN_ATTENTE");

  useEffect(() => {
    store.getData(
      LISTE_ABONNEMENT_VALIDATION_SP,
      { page: 0, param: "", size: 10 },
      `&status=EN_ATTENTE`,
    );
    commentaire.getData("page=0&param=&size=10000000");
  }, []);

  const moreEnAttente = (page) => {
    store.getData(
      LISTE_ABONNEMENT_VALIDATION_SP,
      { page: page - 1, param: "", size: 10 },
      `&status=${statut}`,
    );
  };

  return (
    <div className="">
      <div className="lg:flex gap-8 items-center ">
        <h3 className="font-mtn text-3xl font-bold">Validation des ventes</h3>
      </div>

      <div className="bg-white rounded-md px-2 py-4 mt-3">
        <div className="mt-3 lg:flex gap-1 items-center">
          <input
            type="text"
            placeholder="Rechercher element..."
            className="text-xs input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
            onChange={(e) =>
              store.getData(
                LISTE_ABONNEMENT_VALIDATION_SP,
                { page: 0, param: e.target.value, size: 10 },
                `&status=${statut}`,
              )
            }
          />

          <>
            <select
              onChange={(e) => {
                setStatut(e.target.value);
                store.getData(
                  LISTE_ABONNEMENT_VALIDATION_SP,
                  { page: 0, param: "", size: 10 },
                  `&status=${e.target.value}`,
                );
              }}
              className="select"
            >
              <option value="EN_ATTENTE">En attente</option>
              <option value="VALIDE">Validé</option>
              <option value="REJETE">Réjété</option>
            </select>
          </>
        </div>

        <div className=" grid  lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 mt-4 grid-cols-1 gap-5">
          {store?.data?.data?.length === 0 ? (
            <div className="col-span-full py-10 flex flex-col items-center justify-center text-gray-500">
              <svg
                className="w-12 h-12 mb-4 text-gray-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              <p className="text-sm">Aucune validation de vente trouvée.</p>
            </div>
          ) : store?.data?.length !== 0 && !store?.loading ? (
            store?.data?.data?.map((item) => (
              <div className="relative bg-white rounded-xl border-slate-200 border shadow-md">
                <div className="rounded-t-xl flex items-center gap-3 border-b border-dashed border-amber-400 px-2 py-3">
                  <p className="text-[12px] font-semibold">
                    N° {item?.eligibilite?.numeroTicket}
                  </p>

                  <div className="ml-auto flex items-center gap-2">
                    <div
                      className={` px-1 border  rounded-full py-[2px] text-xs ${
                        item?.statusConfirmation === "CONFIRMER"
                          ? "text-green-600"
                          : "text-gray-500"
                      }  font-semibold`}
                    >
                      {item?.statusConfirmation?.toLowerCase()}
                    </div>
                  </div>
                </div>
                <div className=" px-3 py-2 ">
                  <div className="items-center gap-2 space-y-3">
                    <Periode item={item} />
                    <Pbo pbo={item?.eligibilite?.pbo?.nom} port={item?.brin} />
                    <div className="flex gap-1 my-3">
                      <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                      <div>
                        <p className="text-[13px] font-medium">
                          {item?.client?.nomPrenoms}
                        </p>
                        <p className="text-xs flex font-semibold gap-2">
                          <span>{item?.client?.numero}</span> {" | "}{" "}
                          <span>{item?.client?.secondNumero}</span>{" "}
                        </p>
                      </div>
                    </div>

                    <h1 className="text-xs flex gap-1 items-center my-2">
                      Forfait : {item?.forfait?.designation} -{" "}
                      {item?.forfait?.categorie?.replace("_", "").toLowerCase()}
                    </h1>
                    <div className=" gap-1 ">
                      <div>
                        <p className="text-[13px] font-medium">
                          Numero FTTH : {item?.abonnement?.numeroFtth}
                        </p>
                        {/* <p className="text-xs flex font-semibold gap-2">
                              SN : <span>{item?.abonnement?.numeroSerie}</span>
                            </p> */}
                      </div>
                    </div>
                    <h1 className="text-xs flex gap-1 items-center my-2">
                      <AvatarIcon />
                      Equipe en charge : {item?.equipe?.designation}
                    </h1>

                    <div className="pb-3 pt-1 border-b flex gap-4 items-center">
                      <p className="text-xs flex gap-1 items-center font-medium">
                        <HomeIcon />
                        {item?.batiment?.designation}
                      </p>
                      <p className="text-xs flex gap-1 font-medium">
                        <ArchiveIcon /> {item?.equipement?.designation}{" "}
                      </p>
                    </div>
                  </div>
                  <h1 className="my-2 text-[13px] font-medium flex items-center">
                    <SewingPinFilledIcon />
                    {item?.commune + ", " + item?.quartier}
                  </h1>
                  <div className="flex items-center gap-1">
                    <h5 className="text-xs font-medium ">Etape:</h5>
                    <p className=" bg-blue-50 text-blue-900 py-1 px-1 rounded-lg font-medium text-xs truncate">
                      {item?.status?.toLowerCase().replace(/_/g, " ")}
                    </p>
                  </div>
                  {checkTagValidity("POURSUIVRE_VALIDATION_SP") ? (
                    <div className="flex gap-2 mt-3">
                      <button
                        onClick={() => setSelectedIntention(item)}
                        className="btn btn-sm btn-outline text-xs flex-1"
                      >
                        Détails
                      </button>
                      {statut === "EN_ATTENTE" && (
                        <NavLink
                          className="btn btn-sm bg-main font-mtn text-xs font-regular flex-1"
                          to={`poursuivre-intention/${item?.eligibilite?.numeroTicket}/${getStepsPosition("EN_ATTENTE_DE_VALIDATION", param?.data?.VALIDATION_SP)}`}
                        >
                          Poursuivre
                        </NavLink>
                      )}
                    </div>
                  ) : null}
                </div>
              </div>
            ))
          ) : (
            <ContentLoading />
          )}
        </div>
        <div className="my-3 flex justify-end">
          <Pagination
            onChange={(event, newValue) => moreEnAttente(newValue)}
            onSelect={(selectedPage) => moreEnAttente(selectedPage)}
            count={store?.data?.totalPages}
            variant="outlined"
            color="primary"
            shape="rounded"
          />
        </div>

        {/* Modal Détails */}
        {selectedIntention && (
          <IntentionDetailsModal
            item={selectedIntention}
            onClose={() => setSelectedIntention(null)}
          />
        )}
      </div>
    </div>
  );
};

export default ValidationVente;
